import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { PagedResult, ResultOfT } from '../models/response/result';
import { DocumentCabinetModel, DocumentResponseModel, DocumentTypeModel, DocumentTypesModel, DynamicDocumentTypeInbox, GetDocumentInboxRecords, GetDocumentTypeModel, SearchDocumentTypeInbox, SearchRawDataForDynamicObjectModel } from '../models/response/document-search-model';
import { BulkRetryOcrRequest, DocumentPublicMetadataRequestModel, MetadataSearchRequestModel, MoveDocumentsRequest, MoveDocumentsResponse } from '../models/request/metadata-search-request';
import { DocumentTypeResponseModel } from '../models/response/document-type-response';

@Injectable({
  providedIn: 'root'
})
export class DocumentServiceService extends BaseService {

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  GetAllCabinetsForSearchModuleWithCount(companyId: number) {
    return this.get<ResultOfT<DocumentResponseModel[]>>('Document/GetAllCabinetsForSearchModuleWithCount/' + companyId);
  }

  GetCabinetsForSearchModuleForCustomer(userId: number) {
    return this.get<ResultOfT<DocumentResponseModel[]>>('Document/GetCabinetsForSearchModuleForCustomer/' + userId);
  }

  GetAllDocumentTypesByCabinetId(cabinetId: number) {
    return this.get<ResultOfT<DocumentTypesModel[]>>('Document/GetAllDocumentTypesByCabinetId/' + cabinetId);
  }

  GetRawDataForDynamicObject(documentTypeId: number, forCustom: boolean) {
    return this.get<ResultOfT<SearchRawDataForDynamicObjectModel>>('Document/GetRawDataForDynamicObject/' + documentTypeId + '/' + forCustom);
  }

  GetDynamicDocumentTypeInboxData(typeId: number) {
    return this.get<ResultOfT<DynamicDocumentTypeInbox[]>>('Document/GetDynamicDocumentTypeInboxData/' + typeId);
  }

  GetMetadataSearchData(fullTextSearch: string, reqModel: MetadataSearchRequestModel) {
    return this.post<ResultOfT<PagedResult<DynamicDocumentTypeInbox>>>('Document/GetMetadataSearchData' + '/' + fullTextSearch, reqModel);
  }

  UpdateDocumentTypeForPublicMetadata(reqModel: DocumentPublicMetadataRequestModel) {
    return this.post<ResultOfT<boolean>>('Document/UpdateDocumentTypeForPublic', reqModel);
  }


  GetDocumentTypeByDocumentTypeId(documentTypeId: number) {
    return this.get<ResultOfT<DocumentTypesModel>>('Document/GetDocumentTypeByDocumentTypeId/' + documentTypeId);
  }

  GetDocumentTypeWithMetadataById(documentTypeId: number) {
    return this.get<ResultOfT<DocumentTypeModel>>('Document/GetDocumentTypeWithMetadataById/' + documentTypeId);
  }

  GetAllDocumentCabinetsByCompanyId(companyId: number) {
    return this.get<ResultOfT<DocumentCabinetModel[]>>('Document/GetAllDocumentCabinetsByCompanyId/' + companyId);
  }

  GetInboxRecordsByInboxId(inboxId: number) {
    return this.get<ResultOfT<GetDocumentInboxRecords>>('Document/GetInboxRecordsByInboxId/' + inboxId);
  }
  GetInboxRecordsById(inboxId: number) {
    return this.get<ResultOfT<SearchDocumentTypeInbox>>('Document/GetInboxRecordsById/' + inboxId);
  }

  GetDocumentDetailsByTypeId(typeId: number) {
    return this.get<ResultOfT<GetDocumentTypeModel>>('Document/GetDocumentDetailsByTypeId/' + typeId);
  }

  GetDocumentTypeId(documentTypeId: number) {
    return this.get<ResultOfT<DocumentTypeResponseModel>>('Document/GetDocumentTypeById/' + documentTypeId);
  }

  MoveDocuments(reqModel: MoveDocumentsRequest) {
    return this.post<ResultOfT<MoveDocumentsResponse>>('Document/MoveDocuments', reqModel);
  }

  RetryOCR(documentId: number, userId: number) {
    return this.get<ResultOfT<boolean>>('Document/RetryOcr' + '/' + documentId + '/' + userId);
  }

  BulkRetryOcrs(reqModel: BulkRetryOcrRequest) {
    return this.post<ResultOfT<boolean>>('Document/BulkRetryOcr', reqModel);
  }
}
